import React from "react";

export const BsCloseButton = ({onClick}) => {
	return (<button type="button" className="btn-close" onClick={onClick} />);
};

const BsButtonBase = ({onClick, text, disabled=false, btnSize, className}) => {
	return (
		<button
			className={`btn ${btnSize ?? "btn-sm"} ${disabled ? "disabled" : ""} ${className || ""}`}
			onClick={onClick}
		>
			{text}
		</button>
	);
};

export const BsButton = ({onClick, text, disabled=false, outline=false, btnSize, className}) => {
	return (
		<BsButtonBase
			onClick={onClick}
			text={text}
			disabled={disabled}
			btnSize={btnSize}
			className={`${outline ? "btn-outline-primary" : "btn-primary"} ${className || ""}`}
		/>
	);
};

export const BsSecondaryButton = ({onClick, text, disabled=false, outline=false, btnSize, className}) => {
	return (
		<BsButtonBase
			onClick={onClick}
			text={text}
			disabled={disabled}
			btnSize={btnSize}
			className={`${outline ? "btn-outline-secondary" : "btn-secondary"} ${className || ""}`}
		/>
	);
};

export const BsDangerButton = ({onClick, text, disabled=false, outline=false, btnSmall=true, className}) => {
	return (
		<BsButtonBase
			onClick={onClick}
			text={text}
			disabled={disabled}
			btnSmall={btnSmall}
			className={`${outline ? "btn-outline-danger" : "btn-danger"} ${className || ""}`}
		/>
	);
};

export const BsSuccessButton = ({onClick, text, disabled=false, outline=false, btnSize, className}) => {
	return (
		<BsButtonBase
			onClick={onClick}
			text={text}
			disabled={disabled}
			btnSize={btnSize}
			className={`${outline ? "btn-outline-success" : "btn-success"} ${className || ""}`}
		/>
	);
};
